import { useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { CheckCircle2, Folder, FolderInput, Inbox as InboxIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";

const ICON = { inbox: InboxIcon, done: CheckCircle2, folder: Folder };

// "Move to…" — any folder the inbox exposes (Inbox, Done, Inbox sub-folders).
export function MoveToMenu({ folders, current, onMove }) {
  const [busy, setBusy] = useState(false);
  const options = (folders || []).filter(f =>
    !(current === "inbox" && f.kind === "inbox") && !(current === "done" && f.kind === "done") && f.id !== current);
  if (!options.length) return null;
  const move = async (f) => {
    setBusy(true);
    try { await onMove(f); toast.success(`Moved to ${f.name}`); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" className="h-7 text-[11px] text-slate-600" disabled={busy} data-testid="move-to-btn">
          {busy ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <FolderInput className="w-3 h-3 mr-1" />}Move to…
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[200px]" data-testid="move-to-menu">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wide text-slate-400">Folders</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {options.map(f => {
          const Icon = ICON[f.kind] || Folder;
          return (
            <DropdownMenuItem key={f.id} onClick={() => move(f)} className="text-xs gap-2" data-testid={`move-to-${f.kind === "folder" ? f.id : f.kind}`}>
              <Icon className="w-3.5 h-3.5 text-slate-500" />
              <span className="truncate">{f.name}</span>
              <span className="ml-auto text-[10px] text-slate-400 tabular-nums">{f.total}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
